import React from 'react';

const StatusBadge = ({ status, config }) => {
  const c = config?.[status?.toLowerCase()] || { bg: "#F3F4F6", color: "#1e293b", label: status || "Unknown" };
  return (
    <span
      style={{
        backgroundColor: c.bg,
        color: c.color,
        padding: "4px 12px",
        borderRadius: "20px",
        fontWeight: "600",
        fontSize: "12px",
        display: "inline-block",
        whiteSpace: "nowrap",
      }}
    >
      {c.label}
    </span>
  );
};

export default StatusBadge;